type inputprops = {
    className: string;
    type: string;
    name: string;
    id: any;
    placeholder?: string;
    [key: string]: any;
}
const Input = ({ className, type, name, id, placeholder, register, required, ...attrs }: inputprops) => {
    if (register) {
        return (

            <input
                {...register(name, { required })}
                type={type}
                className={className}
                id={id}
                // name={name}
                placeholder={placeholder}
                {...attrs}
            />
        )
    } else {
        return (

            <input
                type={type}
                className={className}
                id={id}
                name={name}
                placeholder={placeholder}
                {...attrs}
            />
        );
    }

}
export { Input }